import { Package } from '@features/DynamicPackagesConfigurationWizard/types';

export type PackageInclusion = 'room' | 'spa' | 'dining';

const hasSpaExperience = (packageData: Package) =>
  !!packageData.experiences?.some((experience) =>
    experience.options?.some((option) => option.itemType !== 'spa-extras')
  );

export const getRateInclusions = (packageData?: Package | null): PackageInclusion[] => {
  const inclusions: PackageInclusion[] = ['room'];

  if (!packageData) return inclusions;

  if (hasSpaExperience(packageData)) inclusions.push('spa');
  if (packageData.restaurants?.length) inclusions.push('dining');

  return inclusions;
};

export const getPackageInclusions = (packageData?: Package | null): PackageInclusion[] => {
  if (!packageData) return [];

  const inclusions = getRateInclusions(packageData);

  return inclusions.length > 1 ? inclusions : [];
};
